export default function (text) {
    if (typeof text !== "undefined") {
        return text.trim() || null;
    }
    else {
        return null;
    }
}
